import { render, staticRenderFns } from "./RotationHome.vue?vue&type=template&id=8763079c&scoped=true&"
import script from "./RotationHome.vue?vue&type=script&lang=js&"
export * from "./RotationHome.vue?vue&type=script&lang=js&"
import style0 from "./RotationHome.vue?vue&type=style&index=0&id=8763079c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8763079c",
  null
  
)

export default component.exports